export const en = {
    titre: "Home",
    titreOnglet: "AccèsD Affaires | Desjardins"
};
